module.exports = __webpack_public_path__ + "static/media/empty-placeholder.d14d2f65.svg";